/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum ContextMenuActionEnum {
    PUT_IN_PATH = 'Put in path',
    CONNECT = 'Connect',
    EDIT = 'Edit',
    DELETE = 'Delete'
}
